<script>
    import { get } from 'svelte/store'

    import page from 'page'
    import { orderId, orderInfo } from './store'
    let stripe = Stripe("pk_live_51HM2ThGBFtw9haB8qZ0f8xV39EeRX5NNbWAwvGaPhxYTU37shWGVn2Hcr8Z5uPnQmg7FomxbbwGlKfFHHLPVBTUG00AyOu9ed5");
    let api = 'https://us-central1-postcards-4bbc9.cloudfunctions.net/'

    let info = get(orderInfo);
    let id = get(orderId);

    const gotoEdit = () => {
        page('/');
    };

    const checkoutHandler = () => {
        getCheckoutSession()
        .then(session => {
            return stripe.redirectToCheckout({sessionId: session.id});
        })
        .then(result => {
            if (result.error) {
                alert(result.error.message);
            }
        })
        .catch(error => {
            console.log('Error: ', error);
        });
    }

    async function getCheckoutSession() {
        const url = api + 'getCheckoutSession';
        const params = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                orderId: id
            })
        };
        return (await fetch(url, params)).json();
    }
</script>

<main>
    <div class="flex flex-col md:flex-row">
        <script src="https://js.stripe.com/v3/"></script>
        <div class="md:w-1/2 md:border-r border-gray-400">
            <div class="mx-2 border-gray-400 p-4">
                <div class="border rounded-md text-lg text-left">
                    <div class="relative p-2 py-2">
                        <button on:click={gotoEdit} class="absolute editButton w-1/5 mr-2 mt-2 font-bold bg-white focus:outline-none border border-gray-400 rounded-sm">Edit</button>
                        <div class="w-1/5 font-bold text-2xl leading-none">Header</div>
                        <span class="text-gray-600">{info.card.header}</span>
                        <div class="w-1/5 font-bold text-2xl leading-none">Content</div>
                        <div class="text-gray-600 border-b border-gray-400 break-normal">{info.card.content}</div>
                        <div class="w-1/5 mt-2 font-bold text-2xl leading-none">From</div>
                        <div class="text-gray-600 border-b border-gray-400">
                            <span>{info.fromAddress.name}</span><br/>
                            <span>{info.fromAddress.address_1}</span><br/>
                            {#if info.fromAddress.address_2}
                                <span>{info.fromAddress.address_2}</span><br/>
                            {/if}
                            <span>{info.fromAddress.city}, {info.fromAddress.state} {info.fromAddress.zip}</span>
                        </div>
                        <div class="w-1/5 mt-2 font-extrabold text-2xl leading-none">To</div>
                        <div class="text-gray-600">
                            <span>{info.toAddress.name}</span><br/>
                            <span>{info.toAddress.address_1}</span><br/>
                            {#if info.toAddress.address_2}
                                <span>{info.toAddress.address_2}</span><br/>
                            {/if}
                            <span>{info.toAddress.city}, {info.toAddress.state} {info.toAddress.zip}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="md:w-1/2 h-full md:mx-2 border-gray-400 flex flex-col justify-around">
            <div class="text-4xl mb-4">
                <div class="flex md:flex-col justify-center">
                    <div class="md:border-b-2 border-gray-400 font-bold md:w-1/4 mx-auto">Total:</div><div class="mx-auto">$2.00</div>
                </div>
            </div>
            <div>
                <button id="checkout-button" on:click={checkoutHandler} class="w-5/6 md:w-2/3 bg-black text-white py-2 px-4 border rounded-md">Checkout</button>
            </div>
        </div>
    </div>
</main>

<style>
    .editButton {
        right: 0;
        top: 0;
    }
</style>